import { useCallback, useEffect, useState } from 'react';
import { IEditingTradingFields } from '../types';

const initialState: IEditingTradingFields = {
  stopLoss: false,
  takeProfit: false,
  limitBuy: false,
  limitSell: false,
  marketAmount: false,
  limitAmount: false,
};

export interface IUseEditingTradingFieldsOutput {
  isEditedFields: IEditingTradingFields;
  toggleEditField: (
    fieldName: keyof typeof initialState,
    value?: boolean
  ) => void;
  clearEditingFields: () => void;
}

export const useEditingTradingFields = (): IUseEditingTradingFieldsOutput => {
  const [isEditedFields, setIsEditedFields] =
    useState<typeof initialState>(initialState);

  useEffect(() => {
    return () => {
      setIsEditedFields(initialState);
    };
  }, []);

  const toggleEditField: IUseEditingTradingFieldsOutput['toggleEditField'] =
    useCallback((fieldName, value = true) => {
      setIsEditedFields(prev => ({ ...prev, [fieldName]: value }));
    }, []);

  const clearEditingFields: IUseEditingTradingFieldsOutput['clearEditingFields'] =
    useCallback(() => {
      setIsEditedFields(initialState);
    }, []);

  return {
    isEditedFields,
    toggleEditField,
    clearEditingFields,
  };
};
